import { jsx } from "react/jsx-runtime";
import { Suspense, lazy, useMemo } from "react";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-courses-search.tsx
var LazyCoursesSearch = lazy(() => import("./courses-search-CUduBaoK.js").then((n) => n.n).then((module) => ({ default: module.CoursesSearch })));
function CoursesSearch({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-search" }),
		children: /* @__PURE__ */ jsx(LazyCoursesSearch, { ...props })
	});
}
function CoursesSearchContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-search" }),
		children: /* @__PURE__ */ jsx(LazyCoursesSearch, { ...props })
	});
}
var useCoursesSearchContent = () => {
	return useMemo(() => ({ coursesSearch: { component: CoursesSearchContent } }), []);
};
//#endregion
export { CoursesSearch, useCoursesSearchContent };
